import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import NoData from '../../../components/NoData/NoData';

const TotalAmountChart = () => {
    const categories = [
        'Mar 01', 'Mar 02', 'Mar 03', 'Mar 04', 'Mar 05', 'Mar 06', 'Mar 07',
        'Mar 08', 'Mar 09', 'Mar 10', 'Mar 11', 'Mar 12', 'Mar 13', 'Mar 14',
        'Mar 15', 'Mar 16', 'Mar 17', 'Mar 18', 'Mar 19', 'Mar 20', 'Mar 21',
        'Mar 22', 'Mar 23', 'Mar 24', 'Mar 25', 'Mar 26', 'Mar 27', 'Mar 28',
        'Mar 29', 'Mar 30', 'Mar 31'
    ];

    const columnData = [
        null,  // Mar 01
        320,   // Mar 02
        450,   // Mar 03
        500,   // Mar 04
        160,   // Mar 05
        400,   // Mar 06
        250,   // Mar 07
        null,  // Mar 08
        null,  // Mar 09
        330,   // Mar 10
        120,   // Mar 11
        230,   // Mar 12
        480,   // Mar 13 (highlighted)
        320,   // Mar 14
        null,  // Mar 15
        null,  // Mar 16
        470,   // Mar 17
        300,   // Mar 18
        220,   // Mar 19
        380,   // Mar 20
        470,   // Mar 21
        null,  // Mar 22
        null,  // Mar 23
        350,   // Mar 24
        230,   // Mar 25
        460,   // Mar 26
        410,   // Mar 27
        320,   // Mar 28
        null,  // Mar 29
        null,  // Mar 30
        340    // Mar 31
    ];

    const lineData = [...columnData];

    const columnColors = columnData.map((val, index) =>
        index === 12 ? '#FF8328' : '#d3dce6'
    );

    // Data Empty
      const isEmpty = columnData.every((val) => val === null || val === undefined);

    const options = {
        chart: {
            height: 350,
        },
        title: {
            text: 'Total amount per day',
            align: 'left',     // 👈 aligns title to the left
            x: 0,
            style: {
                fontWeight: '500', // optional styling
                fontSize: '17px',
                color: '#1A1F36'
            }
        },
        xAxis: {
            categories,
            crosshair: true,
        },
        yAxis: {
            min: 0,
            max: 550,
            title: {
                text: null,
            },
        },
        tooltip: {
            shared: true,
        },
        plotOptions: {
            column: {
                borderRadius: 3,
                pointPadding: 0.2,
                groupPadding: 0.1,
            },
            series: {
                marker: {
                    enabled: true,
                    radius: 4,
                    symbol: 'circle',
                    fillColor: '#fff',
                    lineWidth: 2,
                },
                connectNulls: false, // keeps line broken where data is missing
            },
        },
        series: [
            {
                type: 'column',
                name: 'Total',
                data: columnData.map((val, i) => ({
                    y: val,
                    color: columnColors[i],
                    states: {
                        hover: {
                            color: '#FF8328', // hover color for any bar
                        },
                    },
                })),
            },
            {
                type: 'line',
                name: 'Total Line',
                data: lineData,
                color: '#f57c00',
                marker: {
                    lineColor: '#fff',
                    lineWidth: 2,
                    fillColor: '#FF8328',
                },
            },
        ],
        credits: {
            enabled: false,
        },
    };

   return isEmpty ? <NoData /> : <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default TotalAmountChart;
